import React from 'react';
import { useNavigate } from '@tanstack/react-router';
import { useForm } from 'react-hook-form';
import { Button } from '@daater/ui';
import { usePasswordRecoveryMutation } from '../api/queries';

type RecoveryInput = { email: string };

export default function PasswordRecoveryScreen() {
  const navigate = useNavigate();
  const recoveryMutation = usePasswordRecoveryMutation();
  const [sent, setSent] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState<string | null>(null);

  const { register, handleSubmit } = useForm<RecoveryInput>();

  const onSubmit = async (values: RecoveryInput) => {
    setErrorMessage(null);
    try {
      await recoveryMutation.mutateAsync(values.email);
      setSent(true);
    } catch (error) {
      setErrorMessage((error as Error).message);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-pale-grey px-4">
      <div className="w-full max-w-md rounded-xl border border-pale-grey-three bg-white p-6 shadow-sm">
        <h1 className="text-2xl font-semibold text-charcoal-grey">Recuperar contraseña</h1>
        <p className="mt-1 text-sm text-slate">
          Ingresa tu correo para enviarte el enlace de recuperación.
        </p>

        {sent ? (
          <div className="mt-6 rounded-md border border-greenish-teal/30 bg-greenish-teal/10 px-3 py-3 text-sm text-greenish-teal">
            Te enviamos un correo con las instrucciones para restablecer tu contraseña.
          </div>
        ) : (
          <form className="mt-6 space-y-4" onSubmit={event => void handleSubmit(onSubmit)(event)}>
            <div>
              <label className="text-xs font-semibold uppercase text-slate">Correo</label>
              <input
                type="email"
                {...register('email')}
                className="mt-1 w-full rounded-md border border-pale-grey-three px-3 py-2 text-sm"
                placeholder="correo@empresa.com"
              />
            </div>

            <Button type="submit" className="w-full">
              {recoveryMutation.isPending ? 'Enviando...' : 'Enviar'}
            </Button>
            {errorMessage ? <p className="text-xs text-darkish-pink">{errorMessage}</p> : null}
          </form>
        )}

        <button
          type="button"
          onClick={() => void navigate({ to: '/login' })}
          className="mt-4 text-xs text-slate underline"
        >
          Volver al login
        </button>
      </div>
    </div>
  );
}
